import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    confirmList: {
      paddingLeft: 0,
      marginBottom: '0.75rem',
    },
    confirmHeader: {
      padding: '30px 20px 15px 3.75rem',
    },
  };
});

export { useStyles };
